import CompanyViewAnnouncement from 'components/company-view/announcement/company-view-announcement';

import './company-view-announcement.desktop.scss';

export default CompanyViewAnnouncement;
